<template>

  <modal  :loading="loading" titulo="Cadastro Rápido de Ato" :fechar="true" @close="close">

    <template #default>
      <div id="aba-dados-principais">
        <card>
          <div class="row gutters-xs ato">
              <v-input :error="validation.codigo" class="col-4" label="Código"
                       type="number" v-model="form.codigo"/>

            <v-input :error="validation.registro" class="col-8" label="Registro"
                     type="date" v-model="form.registro" :max="today"/>

              <v-input :error="validation.titulo" class="col-12" label="Titulo"
                       type="text" v-model="form.titulo"/>
          </div>
        </card>
      </div>
    </template>
    <template #footer>
      <button @click.prevent="close()" class="btn btn-outline-secondary mr-auto" type="button">Fechar</button>
      <v-button :run="salvar" class="btn-outline-primary" >Salvar & Continuar</v-button>
    </template>

  </modal>

</template>

<script>

import FrontBusiness from "@/business/FrontBusiness.js";
import AtoLegadoBusiness from "@/business/indicadores/AtoLegadoBusiness.js";
import Card from "@/components/Layout/components/Card.vue";

import Modal from "@/components/Modal";
import Utils from "@/commons/Utils";

export default {

  name: "ModalCadastroAtoLegado",
  components: {
    Modal,
    Card,
  },

  modal: {
    width: 500,
    escapable: false
  },

  props: {
    ato: Object,
    ficha: Object,
  },

  created() {
    this.$set(this, 'loading', false);
  },

  data() {
    return {
      validation: {},
      form: {},
      validacao: true,
      loading : true,
    }
  },

  computed:{
    today(){
      return new Date().toISOString().split(".")[0];
    }
  },

  mounted() {
    this.$set(this.form, 'codigo', this.ato.codigo);
    this.$set(this.form, 'registro', this.ato.registro);
    this.$set(this.form, 'titulo', this.ato.titulo);
    this.$set(this.form, 'tipo', this.ato.tipo);
  },

  methods: {

    close() {
      FrontBusiness.closeModal(this.validacao)
    },

    async salvar() {
      let dto = {};
      this.form.indicadorReal = this.ficha;
      this.form.livro = 'MATRICULA';
      dto = Utils.clone(this.form);
      if(!dto.registro){
        FrontBusiness.showError('', 'Necessário informar a data de registro');
        return false;
      }
      dto.registro = dto.registro + 'T00:00:00';
      let atoId = await AtoLegadoBusiness.saveByIa(dto, this.form?.id).catch(this.showError);
      if (atoId) {
        FrontBusiness.showSuccess('', 'Ato salvo com sucesso');
        this.close();
        return true;
      }
    },

    showError(e) {
      FrontBusiness.showError('', e.message);
    },
  }
}
</script>
